import type Highcharts from 'highcharts';

type HighchartsLike = typeof Highcharts;

let loggerRegistered = false;

export function registerHighchartsErrorLogger(H: HighchartsLike) {
  if (!H || typeof H.error !== 'function') {
    return;
  }
  if (loggerRegistered) {
    return;
  }

  const originalError = H.error;

  H.error = function patchedHighchartsError(
    this: unknown,
    message: any,
    fatal?: boolean,
    chart?: Highcharts.Chart,
    ...rest: any[]
  ) {
    if (chart) {
      const customMeta = (chart.options as Highcharts.Options & { custom?: Record<string, unknown> }).custom;
      const debugMeta = {
        component: customMeta?.component,
        chartTitle: customMeta?.chartTitle ?? chart.options?.title?.text,
        gridIndex: customMeta?.gridIndex,
        prism: customMeta?.prism,
        additionalMeta: customMeta,
        fatal,
        rest,
      };
      // eslint-disable-next-line no-console
      console.error('[Highcharts error captured]', message, debugMeta);
    } else {
      // eslint-disable-next-line no-console
      console.error('[Highcharts error captured]', message, { fatal, rest });
    }

    if (typeof originalError === 'function') {
      return (originalError as typeof H.error).call(this, message, fatal, chart, rest?.[0]);
    }

    return undefined;
  } as typeof H.error;

  loggerRegistered = true;
}
